import { createSelector } from 'reselect';

import { RootState } from 'client/redux/index';
import { ClientRoomData } from 'models/room/interface';
import { ROOM_STATUS } from 'constants/index';

export const selectRoomDbData = (store: RootState): ClientRoomData | null => {
  return store.room.roomData;
};

export const selectIsBusy = (store: RootState): boolean => {
  return store.room.isBusy;
};

export const selectRoomSpeakers = createSelector(selectRoomDbData, (room) => {
  return room?.speakers;
});

export const selectRoomStatus = createSelector(selectRoomDbData, (room) => {
  return room?.status || ROOM_STATUS.INACTIVE;
});

export const selectNeedToRecord = createSelector(selectRoomDbData, (room) => {
  return room?.needToRecord || false;
});

export const selectRoomId = createSelector(selectRoomDbData, (room) => {
  return room?._id || '';
});
